import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
export function Guarantee() {
  return <section className="py-16 px-4 bg-[#0a0a0a] relative" data-id="element-133">
      <div className="max-w-4xl mx-auto" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-brand-card to-black border border-gray-800 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-135">
          {/* Background shield watermark */}
          <ShieldCheck className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 text-white/[0.02] pointer-events-none" data-id="element-136" />

          <div className="relative z-10" data-id="element-137">
            <div className="w-24 h-24 bg-brand-gold/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-138">
              <ShieldCheck className="w-12 h-12 text-brand-gold" data-id="element-139" />
            </div>

            <h2 className="text-3xl md:text-5xl font-oswald font-bold text-white mb-6" data-id="element-140">
              Garantía de Resultados de{' '}
              <span className="text-brand-gold" data-id="element-141">30 Días</span> o Te Devolvemos
              Tu Dinero
            </h2>

            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-142">
              Si en 30 días no empezás a ver resultados reales en tu control
              sexual, te devolvemos el{' '}
              <strong className="text-white underline decoration-brand-gold/50 underline-offset-4" data-id="element-143">
                100% de tu dinero
              </strong>{' '}
              <strong className="text-brand-red" data-id="element-144">sin hacer preguntas</strong>.
            </p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center" data-id="element-145">
              <Button data-id="element-146">QUIERO ESTA OFERTA</Button>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}